import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CREATE_GOOGLE_AD_MANAGER_CONNECTION: TypedDocumentNode<Data, { input: Variables }> =
  gql`
    ${ERROR_FRAGMENT}

    mutation createGoogleAdManagerConnection($input: CreateGamConnectionOrderInput!) {
      createGamConnectionOrder(input: $input) {
        errors {
          ...ErrorFragment
        }
      }
    }
  `
